export { api as apiConfig } from './api';
export { app as appConfig } from './app';
export { seo as seoConfig } from './seo';

export {
	route as routeConfig,
	setting as routeSetting,
} from './route';
